export function initHoneyPot() {
  (document.querySelector(".website") as HTMLDivElement).style.display = "none";
}
